import React from "react";
import { Link, Navigate } from "react-router-dom";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import FameWallNaati from "../components/Frontend/FameWallNaati";
import Testimonial from "../components/Frontend/Testimonial";
import VideoTestimonial from "../components/Frontend/VideoNaatiTestimonial";
import NaatiTut from "../components/Frontend/NaatiTut";
import SimpleReactValidator from "simple-react-validator";
import { store } from "store/index";
import { setAlert } from "action/index.js";
import API from "api.js";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import Slider from "react-slick";
import PhoneInputField from "components/Inputs/PhoneInputField";

class Pte extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
      name: "",
      email: "",
      phone: "",
      course: "NAATI CCL Online",
      lang: "Hindi",
      query: "",
      flag: false,
      readMoreFlag: false,
      loginLock: false,
    };
    this.validator = new SimpleReactValidator();
  }
  handleClick = () => {
    this.setState((prevState) => ({
      isActive: !prevState.isActive,
    }));
  };
  componentDidMount() {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    
    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();
  }
  submitForm = (e) => {
    e.preventDefault();
    this.hitApi();
  };

  hitApi = async () => {
    if (this.state.loginLock) {
      return;
    }
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
      return;
    }
    this.setState({ loginLock: true });

    var bodyFormData = new FormData();
    bodyFormData.set("email", this.state.email);
    bodyFormData.set("name", this.state.name);
    bodyFormData.set("phone", this.state.phone);
    bodyFormData.set(
      "message",
      "<b>course:</b> " +
        this.state.course +
        "<br/><b>Query:</b> " +
        this.state.query
    );
    bodyFormData.set(
      "data",
      "email: " +
        this.state.email +
        ",name: " +
        this.state.name +
        ",phone: " +
        this.state.phone +
        ",course: " +
        this.state.course +
        ",query: " +
        this.state.query
    );
    bodyFormData.set("page", "IELTS coaching Sydney");
    let res = null;
    try {
      res = await API({
        method: "POST",
        url: "sendOnlinePte",
        data: bodyFormData,
      });
    } catch (error) {}
    console.log(res);
    if (res?.status === 200) {
      store.dispatch(
        setAlert({ flag: true, type: 1, message: res.data.message })
      );
      this.setState({
        name: "",
        email: "",
        phone: "",
        course: "PTE On-Campus",
        query: "",
        loginLock: false,
        flag: true,
      });
    } else {
      this.setState({ loginLock: false });
    }
  };

  changeReadMore = () => {
    this.setState({ readMoreFlag: !this.state.readMoreFlag });
  };

  changeInput = (e) => {
    let { name, value } = e.target;
    this.setState({ [name]: value });
  };
  render() {
    if (this.state.flag) {
      return <Navigate to="/thank-you" replace />;
    }

    const customslider = {
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
    };

    return (
      <React.Fragment>
        <Helmet>
          <title>NAATI CCL Coaching in Sydney | Language Academy</title>
          <meta
            name="twitter:title"
            content="IELTS Classes in Sydney - Language Academy"
          />
          <meta
            property="og:title"
            content="IELTS Classes in Sydney - Language Academy"
          />
          <meta
            name="description"
            content="Attend NAATI CCL coaching classes in Sydney with Language Academy. Benefit from expert instruction and targeted practice to achieve your certification."
          />
          <meta
            name="twitter:description"
            content="Are you searching for the best PTE coaching classes in Parramatta that can help you achieve sure-shot success in your exam? Language Academy, the top PTE training institute in Sydney, provides both in-class and online coaching to help the students to improve their scores in the Pearson Test Of English. To get demo classes from the leading PTE Coaching centre, contact at +61 426230061."
          />
          <meta
            property="og:description"
            content="Are you searching for the best PTE coaching classes in Parramatta that can help you achieve sure-shot success in your exam? Language Academy, the top PTE training institute in Sydney, provides both in-class and online coaching to help the students to improve their scores in the Pearson Test Of English. To get demo classes from the leading PTE Coaching centre, contact at +61 426230061."
          />
        </Helmet>
        <Header />
        <div className="hero-section ncs-hero-section mt-80">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-8 col-md-8">
                <div className="hero-content">
                  <h1 className="primary-heading mfw-600">
                    Training Centre in <br className="d-none d-lg-block" />
                    Sydney for NAATI CCL <br className="d-none d-lg-block" />{" "}
                    Exam Preparation
                  </h1>
                  <div className="text-center text-md-start">
                    <a href={`${import.meta.env.VITE_NAATI_URL}auth/register`} className="primary-btn">
                      REGISTER NOW{" "}
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="hero-img-wrapper">
                  <img
                    className="img-fluid"
                    src="/images/web-new-images/bannerImg.png"
                    alt="LA"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="pte-content-section ncp-content-section pb-0">
          <div className="circle-section py-0">
            <div className="container pte-container">
              <div className="row">
                <h2 className="primary-heading pte-icon-heading position-relative text-center">
                  Why Sydney Is <br className="d-none d-md-block" /> the Best
                  Location for <br className="d-none d-md-block" />
                  <span className="wpl-badge pte-naati-badge text-white">
                    NAATI CCL Coaching Classes?
                  </span>
                  <img
                    className="emoji-img"
                    src="/images/web-new-images/emojis/smile-icon.png"
                    alt="LA"
                  />
                </h2>
                <div className="col-md-12">
                  <div className="position-relative">
                    <ul className="m-0">
                      <li>
                        Sydney is one of the most popular destinations for
                        higher education among international students. Preparing
                        for NAATI CCL Coaching in Sydney helps gain the five
                        precious points towards Australian PR. Sydney has many
                        government and private educational institutes, which
                        makes it an excellent place to pursue higher education.
                      </li>
                      <li>
                        Sydney has a diverse population of various nations and
                        ethnicity. Citizens welcome and accommodate any
                        international student with open hearts. This is one of
                        the reasons why NAATI CCL Coaching Classes in Sydney are
                        the most preferred choices among the entire continent.
                      </li>
                    </ul>
                  </div>
                  <div className="pte-bottom-content">
                    <div>
                      <div
                        onClick={this.handleClick}
                        className="pte-bottom-header d-flex justify-content-center align-items-center"
                      >
                        <h3 className="m-0">
                          <a
                            href="javascript:void(0)"
                            className="text-decoration-none"
                          >
                            Read More
                          </a>
                        </h3>
                        <img
                          src="/images/web-new-images/icons/bottom-arrow-01.png"
                          alt="LA"
                        />
                      </div>
                      <ul
                        className={`hide-content ${
                          this.state.isActive ? "active" : ""
                        }`}
                      >
                        <li>
                          <h4 className="pte-bottom-heading">
                            How Can NAATI CCL Coaching Classes in Sydney Help
                            You?
                          </h4>
                          When you think of taking a NAATI CCL test, you need to
                          understand this clearly that NAATI CCL can be taken
                          both online and offline. However, the testing body
                          doesn’t run any NAATI CCL Classes in Sydney of its
                          own.
                        </li>
                        <li>
                          Language Academy offers both online and offline
                          courses, which are very helpful in grabbing the five
                          essential points for Australian PR. Students who can
                          come to our campus can enrol in our on-campus program.
                          The students who are unable to attend our on-campus
                          course due to some reasons can enrol in our online
                          course.
                        </li>
                        <li>
                          We are a very popular NAATI CCL training centre in
                          Sydney with the highest success rate.
                        </li>
                        <li>
                          <h4 className="pte-bottom-heading">
                            What is NAATI CCL?
                          </h4>
                          NAATI CCL Test helps in assessing an aspirant’s
                          language skills at a community level in many
                          languages. It assesses the excellence of an aspirant
                          to translate the conversation dialogues from Language
                          other than English (LOTE) to English and vice versa.
                          We at Language Academy help the aspirants to take the
                          NAATI CCL test in 10 different languages like Hindi,
                          Punjabi, Urdu, Nepali, Bangla, Tamil, Telugu,
                          Malayalam, Gujarati and Sinhalese.
                        </li>
                        <li>
                          The test has a recording of dialogues between people,
                          and test-takers have to listen to these recordings.
                          There are two dialogues in each recording, and each
                          has 35-word short stanzas, carrying 45 marks. Securing
                          a minimum of 29 is mandatory to qualify for a valid
                          score.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-center">
                <a href={`${import.meta.env.VITE_NAATI_URL}auth/register`} className="primary-btn">
                  REGISTER NOW{" "}
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="exam-pattern-section pte-exam-pattern pcs-exam-pattern">
          <div className="container">
            <div className="row">
              <h2 className="primary-heading text-center">
                Why choose <br className="d-block" /> Language Academy{" "}
                <br className="d-block" />
                <span className="wpl-badge pte-naati-badge text-white">
                  {" "}
                  NAATI CCL Exam Preparation
                </span>
              </h2>
              <div className="pattern-cards-outer my-0">
                <div className="exam-pattern-cards position-relative">
                  <Slider {...customslider}>
                    <div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Experienced Trainer</h3>
                        <p>
                        Our certified faculties help you to use their expertise in improving your reading, writing, listening, and speaking sections.
                        </p>
                      </div>
                    </div>
                    <div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Highest Success Rate</h3>
                        <p>We continuously involve personally with every student, which enables them to unleash the potential in them and achieve the highest scores possible.
                        </p>
                      </div>
                    </div>
                    <div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Free CCL Books</h3>
                        <p>
                        Every student at the Language Academy gets templates to study and understand the best way to write an essay and leave the best impression.
                        </p>
                      </div>
                    </div>
                    <div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Latest Resources</h3>
                        <p>Students can easily access the study material and take practice tests through our mobile app. Just in a few taps, they can get started.
                        </p>
                      </div>
                    </div>
                    <div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Online Support</h3>
                        <p>During the entire class duration, our experts can be reached out to seek any help. They will answer all your questions and help you anywhere you stuck.
                        </p>
                      </div>
                    </div>
                    <div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">100 + Audio Dialogues</h3>
                        <p>We have curated several previous question papers to help our students in practicing the common questions that are asked frequently.
                        </p>
                      </div>
                    </div>
                    <div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Discussion Sessions</h3>
                        <p>Our experts note the weaknesses and strengths of students during the discussion sessions to devise personalized study plans for them.
                        </p>
                      </div>
                    </div>
                    <div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Affordable Fees</h3>
                        <p>Our costs are pocket-friendly so the students can easily pay off their fees and improve their score.
                        </p>
                      </div>
                    </div>
                    <div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Real Time Test Environment</h3>
                        <p>Our mock tests provide the students with the actual experience of taking tests. Students can test their reading, listening, and writing skills.
                        </p>
                      </div>
                    </div>
                  </Slider>
                </div>
                <div className="text-center">
                  <a href={`${import.meta.env.VITE_NAATI_URL}auth/register`} className="dark-border primary-btn">
                    REGISTER NOW{" "}
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <VideoTestimonial title="Success Stories" />
        <div className="why-choosing-section poc-why-choosing ncs-why-sec">
          <div className="container">
            <div className="row">
              <h2 className="primary-heading text-center">
                Language Academy <br className="d-block" /> <span className="wpl-badge text-white">CCL App</span>
              </h2>
              <p className="sub-heading text-center">
                This mobile app consists of preparation with a list of all the
                comprehensive <br className="d-none d-md-block" /> vocabulary as well as dialogues with sample
                answers.
              </p>
              <div className="feature-cards card-56">
                  <div className="feature-card purple-card">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/a-icon.svg"
                          alt="LA"
                        />
                      </div>
                    </div>
                    <h3>
                      Vocabulary in <br /> 7 different categories
                    </h3>
                    <p>
                      A complete list of 2000+ words is included and explained
                      in the various native language with the translation.
                    </p>
                  </div>
                  <div className="feature-card blue-card">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/22.svg"
                          alt="LA"
                        />
                      </div>
                    </div>
                    <h3>
                      Mock tests like <br /> real-time Exam
                    </h3>
                    <p>
                      The feel of the actual test environment helps you to
                      understand properly what can you expect and how to
                      perform.
                    </p>
                  </div>
                  <div className="feature-card greenish-yellow-card">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/33.svg"
                          alt="LA"
                        />
                      </div>
                    </div>
                    <h3>
                      Comprehensive practice <br /> dialogue
                    </h3>
                    <p>
                      Dialogues from different categories and scenarios
                      similar to the ones that came in previous exams are
                      included in it.
                    </p>
                  </div>
                  <div className="feature-card light-apricot-card">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/444.svg"
                          alt="LA"
                        />
                      </div>
                    </div>
                    <h3>80+ practice dialogues</h3>
                    <p>
                      Dialogue with sample responses and answers prepared by
                      certified interpreters are included.
                    </p>
                  </div>
                  <div className="feature-card mint-green-card">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/05.svg"
                          alt="LA"
                        />
                      </div>
                    </div>
                    <h3>Last-minute package</h3>
                    <p>
                      Short packages are given with tips to boost your
                      confidence and prepare well before the Exam.
                    </p>
                  </div>
                </div>
              <div className="text-center bottom-btn-wrapper">
                <p className="sub-heading ">
                  Let’s make your learning meaningful and successful!
                </p>
                <a href={`${import.meta.env.VITE_NAATI_URL}auth/register`} className="primary-btn">
                  REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                </a>
              </div>
            </div>
          </div>
        </div>
         <div className="goals-section why-video-course ncs-goals">
            <div className="container">
              <div className="row">
                <h2 className="primary-heading text-center">
                What you will <br className="d-block" />Get with Us
                </h2>
              </div>
              <div className="single-language-card">
                <div className="language-cards position-relative">
                  <img
                    className="emoji-icon2"
                    src="/images/web-new-images/emojis/emoji-1.png"
                    alt="LA"
                  />
                  <div className="position-relative my-0">                 
                    <div className="language-card">
                      <ul className="p-0 m-0">
                        <li className="tick-list-item">
                          <h3>
                            <img
                              src="/images/web-new-images/icons/check-icon-01.svg"
                              alt="LA"
                            />{" "}
                             Full Access to CCL App
                          </h3>
                        </li>
                        <li className="tick-list-item">
                          <h3>
                            <img
                              src="/images/web-new-images/icons/check-icon-01.svg"
                              alt="LA"
                            />{" "}
                            Access to comprehensive vocabulary with answers
                          </h3>
                        </li>
                        <li className="tick-list-item">
                          <h3>
                            <img
                              src="/images/web-new-images/icons/check-icon-01.svg"
                              alt="LA"
                            />{" "}
                            Access to comprehensive practice dialogues with Sample Answers
                          </h3>
                        </li>
                        <li className="tick-list-item">
                          <h3>
                            <img
                              src="/images/web-new-images/icons/check-icon-01.svg"
                              alt="LA"
                            />{" "}
                            Live Practice Sessions with NAATI certified Interpreter
                          </h3>
                        </li>
                        <li className="tick-list-item">
                          <h3>
                            <img
                              src="/images/web-new-images/icons/check-icon-01.svg"
                              alt="LA"
                            />{" "}
                            Access to Last Minute Practice dialogues with Sample Answers
                          </h3>
                        </li>
                        <li className="tick-list-item">
                          <h3>
                            <img
                              src="/images/web-new-images/icons/check-icon-01.svg"
                              alt="LA"
                            />{" "}
                            Live weekly mock test with Feedback
                          </h3>
                        </li>
                        <li className="tick-list-item">
                          <h3>
                            <img
                              src="/images/web-new-images/icons/check-icon-01.svg"
                              alt="LA"
                            />{" "}
                            Access to Mock Tests with Sample Answers
                          </h3>
                        </li>
                      </ul>
                      <div className="text-center">
                      <button
                          className="primary-btn text-uppercase border-0"
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#staticBackdrop"
                        >
                          {" "}
                          Take a FREE Demo Class
                          <img
                            src="/images/web-new-images/right-arrow.svg"
                            alt="Register Now"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>          
          <div className="feature-section poc-feature-section noc-feature">
            <div className="container">
              <div className="row">
                <h2 className="primary-heading text-center mb-0">
                  How Does it Works?
                </h2>
                <div className="position-relative">                  
                  <div className="feature-cards card-56">
                      <div className="feature-card purple-card">
                        <div className="feature-icon-outer">
                          <div className="img-wrapper">
                            <img
                              src="/images/web-new-images/icons/feature-01.svg"
                              alt="LA"
                            />
                          </div>
                          <div className="feature-count">
                            <span>1</span>
                          </div>
                        </div>
                        <h3>Orientation Class</h3>
                        <p>
                          Here you'll learn the basics of NAATI. The experts
                          will guide you on how to gain maximum score in the
                          test.
                        </p>
                      </div>
                      <div className="feature-card blue-card">
                        <div className="feature-icon-outer">
                          <div className="img-wrapper">
                            <img
                              src="/images/web-new-images/icons/001.svg"
                              alt="LA"
                            />
                          </div>
                          <div className="feature-count">
                            <span>2</span>
                          </div>
                        </div>
                        <h3>Live Practice Session</h3>
                        <p>
                          Our trainers will monitor your performance, and will
                          also give you feedback on your dialogues and vocab.
                        </p>
                      </div>
                      <div className="feature-card greenish-yellow-card">
                        <div className="feature-icon-outer">
                          <div className="img-wrapper">
                            <img
                              src="/images/web-new-images/icons/002.svg"
                              alt="LA"
                            />
                          </div>
                          <div className="feature-count">
                            <span>3</span>
                          </div>
                        </div>
                        <h3>App for CCL Practice</h3>
                        <p>
                          Access to CCL app helping you in excellent listening
                          practice with audio recordings and sample answers.
                        </p>
                      </div>
                      <div className="feature-card light-apricot-card">
                        <div className="feature-icon-outer">
                          <div className="img-wrapper">
                            <img
                              src="/images/web-new-images/icons/003.svg"
                              alt="LA"
                            />
                          </div>
                          <div className="feature-count">
                            <span>4</span>
                          </div>
                        </div>
                        <h3>Weekly Mock Test</h3>
                        <p>
                          You will have weekly tests and will also get a full
                          scorecard suggesting your scores, and areas of
                          improvement.
                        </p>
                      </div>
                      <div className="feature-card mint-green-card">
                        <div className="feature-icon-outer">
                          <div className="img-wrapper">
                            <img
                              src="/images/web-new-images/icons/004.svg"
                              alt="LA"
                            />
                          </div>
                          <div className="feature-count">
                            <span>5</span>
                          </div>
                        </div>
                        <h3>Final Consultation</h3>
                        <p>
                          Once you complete the course, our experts will tell
                          you how much more practice you should do before you
                          book the exam.
                        </p>
                      </div>                     
                  </div>
                </div>
                <div className="text-center">
                  <a href={`${import.meta.env.VITE_NAATI_URL}auth/register`} className="primary-btn dark-border">
                    ARCHIVE YOUR DESIRED SCORE! <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        <FameWallNaati
          title={`Score Cards <br className="d-block" /> of Our <br className="d-block d-md-none" /> <span className="wpl-badge pte-naati-badge text-white">
            NAATI CCL Students
          </span>`}
        />
        <div className="numbers-section ncs-numbers">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-lg-3">
                <div className="number-card-outer">
                  <div className="number-card">
                    <div className="number-card-content">
                      <div className="img-wrapper-outer">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/11.svg"
                            alt="LA"
                          />
                        </div>
                      </div>
                      <h3 className="card-title">5,000+</h3>
                      <p className="card-sub-title">Students Taught</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="number-card-outer">
                  <div className="number-card">
                    <div className="number-card-content">
                      <div className="img-wrapper-outer">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/11.svg"
                            alt="LA"
                          />
                        </div>
                      </div>
                      <h3 className="card-title">5,000+</h3>
                      <p className="card-sub-title">Successful Students</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="number-card-outer">
                  <div className="number-card">
                    <div className="number-card-content">
                      <div className="img-wrapper-outer">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/11.svg"
                            alt="LA"
                          />
                        </div>
                      </div>
                      <h3 className="card-title">1000+</h3>
                      <p className="card-sub-title">Online Success Stories</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="number-card-outer">
                  <div className="number-card">
                    <div className="number-card-content">
                      <div className="img-wrapper-outer">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/11.svg"
                            alt="LA"
                          />
                        </div>
                      </div>
                      <h3 className="card-title">5,000+</h3>
                      <p className="card-sub-title">Total Success Stories</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-center col-lg-12">
                <a href={`${import.meta.env.VITE_NAATI_URL}auth/register`} className="primary-btn">
                  REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                </a>
              </div>
            </div>
          </div>
        </div>
          <Testimonial />
        <NaatiTut title={`NAATI CCL Preparation <br className="d-block" /> <span className="wpl-badge pte-naati-badge text-white">Tutorial Videos</span>`} />
        <div className="faq-section mt-faq">
          <div className="container">
            <div className="row">
              <h2 className="secondary-heading text-center">
                Frequently Asked Questions
              </h2>
              <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      What is the recommended number of PTE mock tests that I
                      should undertake?
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      It is recommended to take three complete PTE mock tests.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      What is the PTE requirement for canada?
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      The minimum PTE score for Bachelor's programs, Advanced
                      Diplomas, and Post Graduate Programs is 60, with a minimum
                      band score of 53. Students with an overall score of 56 and
                      each band score of at least 51 have also been granted
                      study permits.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      What is the duration of a full-length PTE mock test?
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Around 2 hours. Students can attempt the test in one go or
                      by taking short breaks.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
        <div
          className="modal fade"
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog main-popup">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">
                    <img
                      className="img-fluid"
                      src="/images/web-new-images/icons/close-icon2.svg"
                      alt="LA"
                    />
                  </span>
                </button>
              </div>
              <div className="modal-body p-0">
                <div className="form-content-outer m-0">
                  <div className="form-content">
                    <div className="main-popup-img form-img">
                      <img
                        className="img-fluid"
                        src="/images/web-new-images/hero_img-02.png"
                        alt="LA"
                      />
                    </div>
                    <div className="main-popup-content form-content-right">
                      <h4 className="popup-title">Take a FREE Demo Class</h4>
                      <p className="popup-sub-title">
                        Submit Your Details Below
                      </p>
                      <div className="pte-popup-form-start">
                        <form onSubmit={this.submitForm}>
                          <div className="fieldOuter">
                            <label htmlFor="name">Name*</label>
                            <div className="form-input-outer">
                              <input
                                className="form-input"
                                type="text"
                                name="name"
                                placeholder="Name*"
                                value={this.state.name}
                                onChange={(e) => {
                                  this.changeInput(e);
                                }}
                              />
                            </div>
                            {this.validator.message(
                              "Name",
                              this.state.name,
                              "required"
                            )}
                          </div>
                          <div className="fieldOuter">
                            <label htmlFor="PhoneNumber">Phone Number</label>
                            <PhoneInputField
                              id="PhoneNumber"
                              value={this.state.phone}
                              changeEvent={this.handlePhoneChange}
                              addClass="popup-class"
                            />
                            {this.validator.message(
                              "phone",
                              this.state.phone,
                              "required|phone"
                            )}
                            <span className="err phone-error"></span>
                          </div>
                          <div className="fieldOuter">
                            <label htmlFor="email">Email*</label>
                            <div className="form-input-outer">
                              <input
                                className="form-input"
                                type="email"
                                name="email"
                                placeholder="Email*"
                                value={this.state.email}
                                onChange={(e) => {
                                  this.changeInput(e);
                                }}
                              />
                            </div>
                            {this.validator.message(
                              "Email",
                              this.state.email,
                              "required"
                            )}
                          </div>
                          {/* <div className="fieldOuter">
                            <input
                              type="text"
                              name="phone"
                              placeholder="Phone*"
                              value={this.state.phone}
                              onChange={(e) => { this.changeInput(e)} }
                            />
                            {this.validator.message('Phone', this.state.phone, 'required')}
                          </div> */}
                          <div className="fieldOuter">
                            <label htmlFor="center">Center</label>
                            <div className="form-input-outer form-select-wrapper">
                              <select
                                className="form-input"
                                id="center"
                                name="course"
                                value={this.state.course}
                                onChange={(e) => {
                                  this.changeInput(e);
                                }}
                              >
                                <option value="NAATI CCL Online">
                                  NAATI CCL Online
                                </option>
                                <option value="PTE On-Campus">
                                  PTE On-Campus
                                </option>
                                <option value="PTE Online4">PTE Online</option>
                                <option value="NAATI CCL On-Campus">
                                  NAATI CCL On-Campus
                                </option>
                                <option value="IELTS Online1">
                                  IELTS Online
                                </option>
                                <option value="IELTS On-Campus1">
                                  IELTS On-Campus
                                </option>
                              </select>
                            </div>
                          </div>
                          <div className="fieldOuter">
                            <label htmlFor="comments">Language</label>
                            <div className="form-input-outer form-select-wrapper">
                              <select
                                className="form-input"
                                name="lang"
                                value={this.state.lang}
                                onChange={(e) => {
                                  this.changeInput(e);
                                }}
                              >
                                <option value="Hindi">Hindi</option>
                                <option value="Punjabi">Punjabi</option>
                                <option value="Urdu">Urdu</option>
                                <option value="Nepali">Nepali</option>
                                <option value="Bangla">Bangla</option>
                                <option value="Tamil">Tamil</option>
                                <option value="Telugu">Telugu</option>
                                <option value="Sinhalese">Sinhalese</option>
                              </select>
                            </div>
                          </div>
                          <div className="fieldOuter">
                            <label htmlFor="comments">Comments / Query</label>
                            <div className="form-input-outer">
                              <input
                                type="text"
                                className="form-input"
                                name="comments"
                                placeholder="Enter your comments/Query"
                                value={this.state.query}
                                onChange={(e) => {
                                  this.changeInput(e);
                                }}
                              />
                            </div>
                            {this.validator.message(
                              "Query",
                              this.state.query,
                              "required"
                            )}
                          </div>
                          <div className="fieldOuter mb-0">
                            {!this.state.loginLock && (
                              <button
                                className="primary-btn"
                                onClick={(e) => {
                                  this.hitApi();
                                }}
                              >
                                SUBMIT <img
                                  className="img-fluid"
                                  src="/images/web-new-images/right-arrow.svg"
                                  alt="LA"
                                />
                              </button>
                            )}
                            {this.state.loginLock && (
                              <button className="primary-btn">Wait...</button>
                            )}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default Pte;
